import { FaTruck, FaHeadphones, FaShieldAlt } from "react-icons/fa";
import { SiHackthebox } from "react-icons/si";
import React from "react";

const AllServices = () => {
  const features = [
    {
      icon: <FaTruck size={24} className="text-green-600" />,
      title: "Free Shipping",
      description: "Free shipping over ₹5000",
    },
    {
      icon: <FaHeadphones size={24} className="text-green-600" />,
      title: "Great Support 24/7",
      description: "Instant access to Contact",
    },
    {
      icon: <FaShieldAlt size={24} className="text-green-600" />,
      title: "100% Secure Payment",
      description: "We ensure your money is save",
      highlight: true,
    },
    {
      icon: <SiHackthebox size={24} className="text-green-600" />,
      title: "Money-Back Guarantee",
      description: "30 days money-back",
    },
  ];

  return (
    <div className="w-full bg-white px-4 py-8 sm:px-6 lg:px-8">
      <div className="mx-auto flex flex-wrap justify-between items-center gap-4">
        {features.map((feature, index) => (
          <div
            key={index}
            className={`flex items-center gap-3 flex-1 min-w-[200px] px-3 py-4 rounded-md shadow-sm transition-all duration-200 cursor-pointer
    ${feature.highlight ? "border-b-0" : "bg-gray-50"}
    hover:border-b-2 hover:border-green-600 hover:bg-white`}
          >
            <div>{feature.icon}</div>
            <div>
              <h3
                className={`font-semibold text-base ${
                  feature.highlight ? "text-black" : "text-gray-900"
                }`}
              >
                {feature.title}
              </h3>
              <p
                className={`text-sm ${
                  feature.highlight ? "text-gray-600" : "text-gray-600"
                }`}
              >
                {feature.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AllServices;
